module.exports = __webpack_public_path__ + "img/LighteningCardScreenshot-1250h.6e484ba9.webp";